import { Route, Routes } from 'react-router-dom';
import { NotFound, Shipper, Driver } from '@pages';
import Protected from '@components/Protected';

function RoutesShipper() {
  return (
    <Protected>
      <Routes>
        <Route index element={<Shipper />} />
        <Route path="/:id/driver" element={<Driver />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}
export default RoutesShipper;

